import React from 'react';
import { connect } from 'react-redux';
import { Box, Grid, Typography, Button, Container, Link } from '@mui/material';
import i18next from 'i18next';
import style from './contact-seller-info.module.scss';
import { IMAGE_CDN } from '../../../../actions/configuration';
import DeviceBreakPoints from '../../../../deviceBreakPoints';

function ContactSellerInfo(props) {
  const { isDesktopDevice } = DeviceBreakPoints();
  const hrefLink = '/get-in-touch';

  return (
    <Container
      disableGutters={!isDesktopDevice}
      variant='container-max-content'
      sx={{ paddingRight: props?.hidePadding ? '0 !important' : '16px' }}
    >
      <Grid
        md={12}
        sm={12}
        xs={12}
        className={`${style['contact-seller-container']}`}
        sx={{
          backgroundImage: `url(${IMAGE_CDN}background-waves-pattern.png)`,
          backgroundColor: 'primaryBackground.main'
        }}
      >
        <Grid container className={`${style['contact-seller-wrapper']}`}>
          <Grid
            item
            xs={12}
            sm={12}
            md={9}
            lg={9}
            className={`${style['contact-seller-text']}`}
          >
            <Grid py={3} className={`${style['contact-seller-heading']}`}>
              <Typography
                className={`${style['title-text-style']}`}
                align='center'
                component='h4'
                variant='h4'
                color='common.light'
              >
                {i18next.t('CONTACT_SELLER.TITLE_REVAMP')}
              </Typography>
            </Grid>
            <Grid>
              <Typography
                variant='body1'
                className={`${style['any-query-text']}`}
                align='center'
                color='common.light'
              >
                {props?.displaySubText
                  ? props?.displaySubText
                  : i18next.t('CONTACT_SELLER.BODY_REVAMP')}
                <br />
                {props?.displaySubText
                  ? ''
                  : i18next.t('CONTACT_SELLER.BODY2_REVAMP')}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            py={3}
            xs={12}
            sm={12}
            md={3}
            lg={3}
            mx='auto'
            className={`${style['contact-seller-style']}`}
          >
            <Box>
              <Link
                className={`${style['contact-seller-button']}`}
                href={hrefLink}
                target='_blank'
              >
                <Button variant='whiteFilledBtn'>
                  {i18next.t('SHARED.CONTACT_US')}
                </Button>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

const mapStateToProps = (redux_state) => ({
  allMasterData: redux_state.MasterDataReducer.allMasterData
});

export default connect(mapStateToProps, null)(ContactSellerInfo);
